export default __webpack_public_path__ + "static/media/RocketDAO-great-rock.3554fd78.svg";